<script>
	import { createEventDispatcher } from 'svelte'
	import BigIcon from '../../components/Icons/BigIcon.svelte'
	import SideLink from '../../components/SidepanelLink/SidepanelLink.svelte'
	import PeriodSelector from '../../components/PeriodSelector/PeriodSelector.svelte'
	import SearchQuery from '../../components/SearchQuery/SearchQuery.svelte'
	import SidepanelSelect from '../../components/SidepanelFields/SidepanelSelect.svelte'
	import ClientsSideLinks from './ClientsSideLinks.svelte'

	export let model
	export let start
	export let end

	const dispatch = createEventDispatcher()

	let typeFilters = [
		{
			text: 'Tutti gli eventi',
			value: '-1'
		},
		{
			text: 'Straordinari',
			value: '1'
		}
	]

	const onTypeChange = (event) => {
		// console.log ('onTypeChange', event.detail)
		dispatch('type-change', event.detail)
	}
</script>

<div class="SidepanelContent">
	<div class="icon-holder">
		<BigIcon icon="fad fa-user-tie" image={model ? model.image : null} />
	</div>
	{#if model}
		<div class="meta">
			<div class="label">{model.name}</div>
			<div class="text">{model.social_r}</div>
		</div>

		<div class="links">
			<ClientsSideLinks clientId={model.id} />
		</div>

		<div class="search">
			<SearchQuery on:search />
		</div>

		<div class="view-type">
			<SidepanelSelect items={typeFilters} on:select={onTypeChange} />
		</div>

		<div class="time-range">
			<PeriodSelector {start} {end} on:period-change />
		</div>

		<div class="mt-2">
			<button class="btn btn-sm btn-primary w-full" on:click={() => dispatch('create-log')}>
				Aggiungi log ore
			</button>
		</div>
	{/if}
</div>

<style>
	.SidepanelContent {
		padding: 25px 20px 20px 20px;
	}
	.SidepanelContent .icon-holder {
		text-align: center;
		margin-bottom: 10px;
	}
	.SidepanelContent .meta {
		text-align: center;
		margin-bottom: 20px;
	}
	.SidepanelContent .meta .label {
		font-size: 18px;
		line-height: 20px;
		font-weight: 600;
	}
	.SidepanelContent .meta .text {
		font-size: 13px;
		color: var(--text-secondary);
		line-height: 14px;
	}
	.SidepanelContent .time-range {
		margin-top: 10px;
	}
	.SidepanelContent .search,
	.SidepanelContent .view-type {
		margin-top: 10px;
	}
</style>
